export const FETCH_PRODUCTS_STARTED = "FETCH_PRODUCTS_STARTED";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_ERROR = "FETCH_PRODUCTS_ERROR";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_CART = "DELETE_CART";
export const ADD_QTY = "ADD_QTY";
export const REMOVE_QTY = "REMOVE_QTY";
export const TOTAL_COST = "TOTAL_COST";
export const ITEM_QTY = "ITEM_QTY";
